module.exports = __webpack_public_path__ + "img/control_de_calidad2_4-3.aeafc647.webp";